import Image from "next/image";
import { AiOutlineLink, AiOutlineMobile } from "react-icons/ai";
import { Spinner } from "reactstrap";
import _ from "underscore";

//local imports
import classes from "@/styles/carriers/carrier-details.module.css";
import { carrierDetails } from "@/utils/content";
import { useIsMobile } from "@/hooks/useIsMobile";
import TrackingWidget from "../utils/tracking-widget";
import { CarrierType } from "@/@types/CarrierType";

type Props = {
  carrierContent: CarrierType;
};

export default function CarrierDetails({ carrierContent }: Props) {
  const content = carrierDetails.en;
  const isMobile = useIsMobile();

  return (
    <div className="container text-center my-5">
      <Image
        src={carrierContent?.logoPath}
        alt={carrierContent?.name}
        height={150}
        width={150}
      />
      <h1 className="mt-4">
        {carrierContent?.name}&nbsp;{content.title}
      </h1>
      {carrierContent?.trackingSystem && (
        <TrackingWidget carrierContent={carrierContent?.trackingSystem} />
      )}
      <div className="pt-4">
        <a
          href={carrierContent?.website}
          target="_blank"
          className={`badge  rounded-pill text-bg-secondary p-2 mx-2 mb-3 ${
            isMobile ? classes.link : ""
          }`}
        >
          <AiOutlineLink fontSize={25} />
          &nbsp; &nbsp;{" "}
          <span className="text-wrap ">{carrierContent?.website}</span>
        </a>
        {carrierContent?.phone && (
          <a
            href={`telto:${carrierContent?.phone}`}
            className={`btn btn-outline-secondary rounded-pill mx-2 ${
              isMobile ? "mb-3" : ""
            }`}
          >
            <AiOutlineMobile fontSize={25} />
            &nbsp; &nbsp;{carrierContent?.phone}
          </a>
        )}
        <p
          className={`${classes.para1} ${
            isMobile ? "" : "w-50"
          }mx-auto mt-4 text-secondary`}
        >
          {carrierContent?.desc}
        </p>
      </div>
    </div>
  );
}
